import React from 'react';
import { motion } from 'framer-motion';
import { useDb } from '../../hooks/useDb';
import { toMinutes } from '../../utils/time';
const START = 8 * 60;
const END = 19 * 60;
const pos = (hhmm: string) => (Math.min(END, Math.max(START, toMinutes(hhmm))) - START) / (END - START) * 100;
const TICKS = ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00'];

/** Thin day band: meetings, focus blocks and a moving "now" marker. */
export function DayTimeline() {
  const {
    events,
    now
  } = useDb(t => ({
    events: t.calendar,
    now: t.meta.time
  }));
  return <div className="relative min-w-0 flex-1" aria-label={`Dagplanning, nu ${now}`} data-id="element-443" data-mp="151dfwp91u9og">
      <div className="relative h-9" data-id="element-444" data-mp="qa4m03y4625i">
        <span aria-hidden className="absolute inset-x-0 top-1/2 h-px bg-white/10" data-id="element-445" data-mp="v97rfpi0aae0" />
        {events.map(e => {
        const left = pos(e.start);
        const width = Math.max(1.2, pos(e.end) - left);
        const tone = e.kind === 'meeting' ? 'border-accent/50 bg-accent/15 text-ink' : e.kind === 'focus' ? 'border-white/10 bg-white/[0.05] text-ink-soft' : 'border-white/15 bg-white/[0.08] text-ink-soft';
        return <div key={e.id} className={`absolute top-0 flex h-9 items-center overflow-hidden rounded-lg border px-2 ${tone}`} style={{
          left: `${left}%`,
          width: `${width}%`
        }} title={`${e.start} ${e.title}`} data-id="element-446" data-mp="2zzcput9anfpw">
              <span className="truncate text-[13px]" data-id="element-447" data-mp="340g2l6w1ovmw">
                {e.kind === 'focus' ? 'Focus' : e.title.replace(', nieuwe klant', '')}
              </span>
            </div>;
      })}
        <motion.div aria-hidden className="absolute -top-1 bottom-[-4px] w-0.5 rounded-full bg-accent" initial={false} animate={{
        left: `${pos(now)}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-448" data-mp="3dym3pma11xqp" />
      </div>
      <div className="relative mt-1 h-4" data-id="element-449" data-mp="1jmnrrckc2nr4">
        {TICKS.map(t => <span key={t} className="absolute -translate-x-1/2 text-[13px] tabular-nums text-ink-muted" style={{
        left: `${pos(t)}%`
      }} data-id="element-450" data-mp="29ab4eulb0ro0">
            {t.slice(0, 2)}
          </span>)}
      </div>
    </div>;
}